import Splide from '@splidejs/splide';

function mountSmartHomeMobileSlider(el) {
  new Splide(el, {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    speed: 600,
    rewind: true,
    arrows: true,
    pagination: true,
    classes: {
      pagination: 'product-control-smart-home__descriptions-pagination',
      page: 'product-control-smart-home__descriptions-btn',
    },
  }).mount();
}

export const initSmartHomeMobileSlider = () => {
  const descriptionSlider = document.querySelector(
    '[data-product-control-smart-home-descriptions]'
  );

  mountSmartHomeMobileSlider(descriptionSlider);
};
